import { __assign, __extends } from "tslib";
import * as React from 'react';
import { MessageBarBase, MessageBarType, styled, MessageBarButton, } from '@fluentui/react';
import { getAppMessageBarClassNames, getStyles, getMessageBarButtonStyles } from './AppMessageBar.styles';
import { AppLink } from '@ms/acui-link/lib/AppLink';
import { getInputMethodFromEvent } from '@ms/acui-common/lib/commanding';
var AppMessageBar = /** @class */ (function (_super) {
    __extends(AppMessageBar, _super);
    function AppMessageBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getOnActionButtonClickHandler = function (actionButtonProps) {
            return function (ev) {
                if (actionButtonProps && actionButtonProps.onExecute) {
                    actionButtonProps.onExecute({ id: actionButtonProps.id, inputMethod: getInputMethodFromEvent(ev) });
                }
            };
        };
        _this.onFirstActionButtonClick = _this.getOnActionButtonClickHandler(_this.props.firstActionButtonProps);
        _this.onSecondActionButtonClick = _this.getOnActionButtonClickHandler(_this.props.secondActionButtonProps);
        return _this;
    }
    AppMessageBar.prototype.render = function () {
        if (this.props.hidden) {
            return null;
        }
        var _a = this.props, message = _a.message, messageTitle = _a.messageTitle, dismissIconProps = _a.dismissIconProps, dismissButtonAriaLabel = _a.dismissButtonAriaLabel, isMultiline = _a.isMultiline, messageBarIconProps = _a.messageBarIconProps, messageBarType = _a.messageBarType, onDismiss = _a.onDismiss, linkProps = _a.linkProps;
        var classNames = getAppMessageBarClassNames();
        return (React.createElement(FabricMessageBarBaseStyled, { dismissIconProps: dismissIconProps, dismissButtonAriaLabel: dismissButtonAriaLabel, isMultiline: isMultiline, messageBarIconProps: messageBarIconProps, messageBarType: messageBarType, onDismiss: onDismiss, actions: this.renderActionButtonArea() },
            messageTitle && React.createElement("span", { className: classNames.messageTitle }, messageTitle),
            React.createElement("span", { className: classNames.messageText }, message),
            linkProps && React.createElement(AppLink, __assign({}, linkProps))));
    };
    AppMessageBar.prototype.renderActionButtonArea = function () {
        var _a = this.props, firstActionButtonProps = _a.firstActionButtonProps, secondActionButtonProps = _a.secondActionButtonProps;
        return ((firstActionButtonProps || secondActionButtonProps) && (React.createElement("div", null,
            firstActionButtonProps && (React.createElement(MessageBarButton, __assign({}, firstActionButtonProps, { text: firstActionButtonProps.label, type: "MessageBarButtonProps", onClick: this.onFirstActionButtonClick, styles: getMessageBarButtonStyles() }))),
            secondActionButtonProps && (React.createElement(MessageBarButton, __assign({}, secondActionButtonProps, { text: secondActionButtonProps.label, type: "MessageBarButtonProps", onClick: this.onSecondActionButtonClick, styles: getMessageBarButtonStyles() }))))));
    };
    return AppMessageBar;
}(React.Component));
export { AppMessageBar };
var FabricMessageBarBaseStyled = styled(MessageBarBase, getStyles, undefined /* getProps helper */, {
    scope: 'MessageBar',
});
export { MessageBarType as AppMessageBarType };
//# sourceMappingURL=AppMessageBar.js.map